export default __webpack_public_path__ + "static/media/doctor.fd1ff3bc.png";